import { mdsDashboardActions } from './constant';

const { SET_MDS_WORKSHEET_DIRTY } = mdsDashboardActions;

/**
 * BRK-1854: the MDS worksheet has unsaved (client-only) edits. Consulted by
 * the sidebar so global navigation away from the worksheet goes through the
 * PageLeaveConfirmModal flow instead of silently dropping the draft.
 */
export const setMdsWorksheetDirtyAction = (dirty: boolean) => {
  return {
    type: SET_MDS_WORKSHEET_DIRTY,
    payload: dirty,
  };
};
